<template>
  <div>
    <ValidationObserver ref="form">
      <form-toolbar
        :title="getTitle()"
        :showSubmitButton="true"
        :onCloseClick="onCloseButtonClick"
        :onSubmitClick="submit"
        :isSubmitting="isLoading"
      />
      <v-form>
        <v-container>
          <div v-if="!isStatusUpdate">
            <v-row>
              <v-col cols="12" sm="5">
                <ValidationProvider
                  name="First Name"
                  rules="required|max:50"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="passenger.firstName"
                    label="First Name"
                    counter="50"
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="5">
                <ValidationProvider
                  name="Last Name"
                  rules="required|max:50"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="passenger.lastName"
                    label="Last Name"
                    counter="50"
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="5">
                <ValidationProvider
                  name="Passenger No"
                  rules="required|max:50"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="passenger.passengerNo"
                    label="Passenger No. (Davinci No.)"
                    counter="50"
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>
            </v-row>
          </div>
          <v-row v-if="isEdit || !passenger.pickupDateTimeLt">
            <v-col cols="12" sm="5">
              <v-select
                v-model="passenger.pickupLocation"
                :items="locations"
                item-text="name"
                item-value="id"
                return-object
                label="Pickup Location"
                clearable
              />
            </v-col>
            <v-col cols="12" sm="3">
              <v-dialog
                ref="pickupDateMenu"
                v-model="pickupDateMenu"
                transition="scale-transition"
                width="unset"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="passenger.pickupDate"
                    label="Pickup Date"
                    readonly
                    v-on="on"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="passenger.pickupDate"
                  @change="pickupDateSelected"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="pickupDateMenu = false"
                    >Cancel</v-btn
                  >
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="12" sm="2">
              <v-dialog
                ref="pickupTimeMenu"
                v-model="pickupTimeMenu"
                transition="scale-transition"
                max-width="300"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="passenger.pickupTime"
                    label="Pickup Time"
                    readonly
                    v-on="on"
                    clearable
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="pickupTimeMenu"
                  v-model="passenger.pickupTime"
                  format="24hr"
                  full-width
                  @click:minute="pickupTimeMenu = false"
                ></v-time-picker>
              </v-dialog>
            </v-col>
          </v-row>
          <v-row v-if="isEdit || !passenger.dropOffDateTimeLt">
            <v-col cols="12" sm="5">
              <v-select
                v-model="passenger.dropOffLocation"
                :items="locations"
                item-text="name"
                item-value="id"
                return-object
                label="Drop Off Location"
                clearable
              />
            </v-col>
            <v-col cols="12" sm="3">
              <v-dialog
                ref="dropOffDateMenu"
                v-model="dropOffDateMenu"
                transition="scale-transition"
                width="unset"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="passenger.dropOffDate"
                    label="Drop Off Date"
                    readonly
                    v-on="on"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="passenger.dropOffDate"
                  @change="dropOffDateSelected()"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="dropOffDateMenu = false"
                    >Cancel</v-btn
                  >
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="12" sm="2">
              <v-dialog
                ref="dropOffTimeMenu"
                v-model="dropOffTimeMenu"
                transition="scale-transition"
                max-width="300"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="passenger.dropOffTime"
                    label="Drop Off Time"
                    readonly
                    v-on="on"
                    clearable
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="dropOffTimeMenu"
                  v-model="passenger.dropOffTime"
                  format="24hr"
                  full-width
                  @click:minute="dropOffTimeMenu = false"
                ></v-time-picker>
              </v-dialog>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import FormToolbar from '../ui/FormToolbar.vue';
import '../../validators';

export default {
  name: 'PassengerForm',
  components: { FormToolbar, ValidationObserver, ValidationProvider },
  props: {
    passenger: {
      type: Object,
      required: true,
    },
    onSubmitClick: {
      type: Function,
      required: true,
    },
    onCloseButtonClick: {
      type: Function,
      required: false,
    },
    isLoading: {
      type: Boolean,
      required: false,
    },
    isEdit: {
      type: Boolean,
      required: false,
    },
    isStatusUpdate: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      locations: 'locationsStore/getLocations',
      getActiveSite: 'userStore/getActiveSite',
    }),
  },
  data() {
    return {
      pickupDateMenu: false,
      pickupTimeMenu: false,
      dropOffDateMenu: false,
      dropOffTimeMenu: false,
    };
  },
  created() {
    this.$store.dispatch('locationsStore/loadVesselLocations', this.getActiveSite.id);
  },
  methods: {
    submit() {
      this.$refs.form.validate()
        .then((isValid) => isValid && this.onSubmitClick());
    },
    reset() {
      this.$refs.form.reset();
    },
    pickupDateSelected() {
      this.pickupDateMenu = false;
      this.$nextTick(() => {
        this.pickupTimeMenu = true;
      });
    },
    dropOffDateSelected() {
      this.dropOffDateMenu = false;
      this.$nextTick(() => {
        this.dropOffTimeMenu = true;
      });
    },
    getTitle() {
      if (this.isStatusUpdate) return 'Update Passenger';
      if (this.isEdit) return 'Edit Passenger';
      return 'Create Passenger';
    },
  },
};
</script>
